import React from 'react';
import { IonButton, IonContent, IonGrid, IonRow, IonCol } from '@ionic/react';
import { _defaultButtonColor } from './constants';
import buttonTemplate from './templates/ButtonTemplate';
import ButtonTemplate from './templates/ButtonTemplate';

type ButtonProps = {
    label: string;
    onClick: () => void;
};

type SuggestionProps = {
    message: string;
    buttons: ButtonProps[][];
    topPosition?: boolean;
};

const Suggestion: React.FC<SuggestionProps> = ({ message, buttons, topPosition }) => {
    return (
        <IonGrid className={topPosition? "sticky-suggestion-top" :"sticky-suggestion"}>
            <IonRow>
                <IonCol size="12">
                    <div style={{ fontFamily: 'Arial', fontSize: '16px', fontWeight: 'bold' }}>{message}</div>
                </IonCol>
            </IonRow>
            {buttons.map((buttonRow, rowIndex) => (
                <IonRow key={rowIndex} className="ion-justify-content-center">
                    {buttonRow.map((button, buttonIndex) => (
                        <IonCol key={buttonIndex} size="auto">
                            <ButtonTemplate icon={null} text={button.label} onClick={button.onClick} />

                            
                        </IonCol>
                    ))}
                </IonRow>
            ))}
        </IonGrid>
    );
};

export default Suggestion;
